<template>
    <!-- class="is-inline-block ml-1 mr-1" -->
     <section class="">
                <b-field class="commonrules-grp"  label="Hotel average nightly cost is more than $">
                <b-input type="number" class="cstmb-input" v-model="hotelDailyCostGsaDifference" @input="getValue"/>
                 <span class="inputcstmtext">above the applicable GSA rate.</span>
                </b-field> 
                <div ref="topArrow">
               <i class="mdi mdi-help-circle-outline mdi-24px" @click="$popper.togglePopper($refs.topArrow, $refs.topMenu)" > </i><span style="font-size:small">Enter 0 to use the applicable GSA rate, enter a positive number to allow your travelers to spend more than the GSA rate, enter a negative number to set your threshold below the GSA rate.</span>
              <div  ref="topMenu"   class="filterBox popper-popup" style="background: #eee; max-width: 400px;">
                <ul style="list-style-type:disc;" class="is-size-7">Example:
                    <li class="is-size-7">If you enter 0, nightly costs over $100 will be out of policy.</li>
                    <li class="is-size-7">If you enter 20, nightly costs over $120 will be out of policy.</li>
                    <li class="is-size-7">If you enter -20, nightly costs over $80 will be out of policy.</li>
                </ul>
                <div class="popper-arrow"></div></div>
              </div>
            </section>
</template>
<script>



export default {
    name:"HotelDailyCostGsaRate",
    components:{},
    data(){
        return {
            hotelDailyCostGsaDifference: null,
            gsaRate : 100,
            allowNightlyCost : 0,
        }
    },
    methods:{
        getValue() {
            if(this.hotelDailyCostGsaDifference < 0 ) {
                this.allowNightlyCost = parseInt(this.gsaRate) - (parseInt(this.hotelDailyCostGsaDifference)*-1);
            } else {
                this.allowNightlyCost =  parseInt(this.gsaRate) + parseInt(this.hotelDailyCostGsaDifference)
            }
            this.allowNightlyCost =this.allowNightlyCost?this.allowNightlyCost:0;
            this.$emit("hotelDailyCostGsaDifference",this.hotelDailyCostGsaDifference);
        }
    }
}
</script>
<style scoped>

</style>>
